








































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { CARDS, CARD_TRANSLATIONS, cardSorter } from "@dokogd/shared";

@Component({})
export default class DoKoCardSelectionHtml extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  items!: CARDS[];

  @Prop({
    type: Array,
    required: true,
  })
  value!: CARDS[];

  @Prop({
    type: Array,
    default: () => [],
  })
  disabledCards!: CARDS[];

  @Prop({
    type: Boolean,
    default: true,
  })
  showSelected!: boolean;

  get sorted() {
    const cards = [...this.items].sort(cardSorter("default"));
    return cards;
  }

  get renderable() {
    return this.sorted.map((cardId) => {
      return {
        id: cardId,
        color: cardId[0],
        value: CARD_TRANSLATIONS[cardId[1]],
        name: cardId.substr(0, 2),
        selected: this.value.includes(cardId),
        disabled: this.disabledCards.includes(cardId),
      };
    });
  }

  toggleSelection(card: CARDS, selected: boolean, disabled: boolean) {
    if (!disabled) {
      const selectedCards = [...this.value, card];
      if (selected) {
        this.$emit(
          "input",
          selectedCards.filter((v) => v !== card)
        );
      } else {
        this.$emit("input", selectedCards);
      }
    }
  }
}
